import moment from 'moment'
import PropTypes from 'prop-types'
import { PureComponent } from 'react'
import { connect } from 'react-redux'
import { Message } from 'semantic-ui-react'

import RankingTable from './ranking/RankingTable'
import StageSelector from './ranking/StageSelector'

import './Ranking.css'

class Ranking extends PureComponent {
  static getDerivedStateFromProps(props, state) {
    const {
      tournament: {
        id,
        tournament: { stages },
      },
    } = props
    let { stage, tournamentId } = state

    if (tournamentId !== id) {
      stage = props.stage || Ranking.getFirstStage(stages)
      tournamentId = id
    }

    return {
      stage,
      tournamentId,
    }
  }

  static getFirstStage(stages) {
    let actualStage = null
    let lastTime = 0
    const now = moment().utc().valueOf() / 1000

    if (stages && stages.length) {
      ;[actualStage] = stages
      for (let s = 0; s < stages.length; s += 1) {
        const stage = stages[s]

        if (stage.rounds && stage.rounds.length) {
          for (let r = 0; r < stage.rounds.length; r += 1) {
            const round = stage.rounds[r]

            if (round.matches && round.matches.length) {
              for (let d = 0; d < round.matches.length; d += 1) {
                const match = round.matches[d]
                const willStart = match.started_at || match.matched_at

                if (willStart < now && willStart > lastTime) {
                  actualStage = stage
                  lastTime = willStart
                }
              }
            }
          }
        }
      }
    }

    return actualStage
  }

  state = {
    stage: undefined,
    tournamentId: null,
  }

  onStageChange = (stage) => {
    this.setState({ stage })
    this.props.onStageChange(stage)
  }

  render() {
    const {
      highlightedTeams,
      printable,
      tournament: {
        relevant_teams: relevantTeams,
        tournament: {
          is_fair_play_active: fairPlay,
          stages,
          teams_stats: teamsStats,
          tie_breakers_order: tieBreakersOrder,
        },
      },
      widget,
    } = this.props
    const { stage } = this.state

    if (stages && stages.length) {
      const teams = {}
      relevantTeams.forEach((team) => {
        teams[team.id] = team
      })

      return (
        <div className={`SoccerRanking ${printable ? 'printable' : ''}`}>
          <StageSelector onChange={this.onStageChange} printable={printable} stage={stage} stages={stages} />
          <RankingTable
            fairPlay={fairPlay}
            highlightedTeams={highlightedTeams}
            printable={printable}
            stage={stage}
            teams={teams}
            teamsStats={teamsStats}
            tieBreakersOrder={tieBreakersOrder}
            widget={widget}
          />
        </div>
      )
    }

    return (
      <Message className="SoccerRanking__message" color="yellow" size="mini">
        Torneo sin información.
      </Message>
    )
  }
}

Ranking.propTypes = {
  tournament: PropTypes.object.isRequired,

  highlightedTeams: PropTypes.array,
  onStageChange: PropTypes.func,
  printable: PropTypes.bool,
  stage: PropTypes.object,
  widget: PropTypes.bool,
}

Ranking.defaultProps = {
  highlightedTeams: [],
  onStageChange: Function.prototype,
  printable: false,
  stage: undefined,
  widget: false,
}

export default connect(({ auth: { usr: user } }) => ({ viewer: user }))(Ranking)
